import { createContext, useContext } from 'react';

const DashboardRoutePanelContext = createContext({
  isActivePanel: true,
  panelLocation: null,
  panelId: null,
});

export function DashboardRoutePanelProvider({
  isActivePanel = true,
  panelLocation = null,
  // The dashboard TAB's id (`dashboardTabs.js::createDashboardTab`), stable for
  // the life of that tab and unique across tabs. Exposed so a page holding
  // per-tab work can scope it to THIS tab rather than to the org or the route —
  // two tabs on the same path are two separate pieces of work, not one shared
  // one. Used by the import wizard's draft persistence; null outside the cache
  // (tests, or a page rendered without the tab shell).
  panelId = null,
  children,
}) {
  return (
    <DashboardRoutePanelContext.Provider value={{ isActivePanel, panelLocation, panelId }}>
      {children}
    </DashboardRoutePanelContext.Provider>
  );
}

export function useDashboardRoutePanel() {
  return useContext(DashboardRoutePanelContext);
}

export function useDashboardRoutePanelActive() {
  return useContext(DashboardRoutePanelContext).isActivePanel;
}

/**
 * This panel's dashboard-tab id, or null when rendered outside the tab cache.
 *
 * For scoping per-tab state so two tabs on the same route do not share it. Null
 * means "no tab identity available" — callers must decide what that implies
 * rather than substituting a shared default, which would reintroduce the
 * cross-tab collision this exists to prevent.
 */
export function useDashboardRoutePanelId() {
  return useContext(DashboardRoutePanelContext).panelId;
}
